import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const SalesReport = () => {
  const data = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    datasets: [
      {
        label: "Direct client",
        data: [0, ],
        borderColor: "#2D66AD",
        borderWidth: 3,
        fill: false,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: (value) => `${value / 1000}k`,
        },
      },
    },
    plugins: {
      legend: {
        display:false,
        position: "top",
      },
    },
  };

  return (
    <div className="row">
      <div className="col-6"> <h6 className="chart-title">Sales report</h6></div>
      <div className="col-6 d-flex justify-content-end">
  <select className="">
    <option value="" selected>Select an option</option>
    <option value="option1">2024</option>
  </select>
</div>
      <div style={{ height: "280px" }}>
        <Line data={data} options={options} />
      </div>
    </div>

  );
};

export default SalesReport;
